import {routePlanService} from "@/service/routePlan.service";
import {Spinner, Tooltip} from "@nextui-org/react";
import Image from "next/image";
import {useEffect, useState} from "react";

export const ConfirmationPopup = ({
  onConfirm,
  message,
  closePopup,
  reqData
}: any) => {
  const [selectedOption, setSelectedOption] = useState("option2");
  const [neededCreditPoint, setNeededCreditPoint] = useState<number>(0);
  const [creditLoading, setCreditLoading] = useState(false);

  useEffect(() => {
    //console.log("reqData changed:", reqData);
    const getCreditPoints = async () => {
      const formData = new FormData();
      let routeIds = [];

      // Destructure required values from reqData
      const sourceRouteId = reqData?.sourceRoute?.id;
      const targetRouteId = reqData?.routeId;

      // Conditionally push the values into the routeIds array if they are available
      if (targetRouteId) {
        routeIds.push(targetRouteId);
      }
      if (sourceRouteId) {
        routeIds.push(sourceRouteId);
      }

      // Check if there are any routeIds to append
      if (routeIds.length > 0) {
        formData.append("routeIds", routeIds.toString());
        formData.append("type", "2");

        setCreditLoading(true);

        try {
          const response = await routePlanService.checkCredits(formData);
          if (response?.data?.status === "success") {
            setNeededCreditPoint(
              response.data?.data?.reportData?.creditsNeeded || 0
            );
          } else {
            setNeededCreditPoint(0);
          }
        } catch (err) {
          setNeededCreditPoint(0);
          console.error("Error checking credits:", err);
        } finally {
          setCreditLoading(false);
        }
      } else {
        setNeededCreditPoint(0); // Reset if no valid routeIds
      }
    };
    const sourceRouteId = reqData?.sourceRoute?.id;
    const targetRouteId = reqData?.routeId;
    // Run the function on every render but only proceed with the logic if necessary
    // getCreditPoints();
    if (targetRouteId || sourceRouteId) {
      getCreditPoints();
    }
  }, []);

  if (!message) return null;
  const {option1, option2} = message.options;
  const clickYes = () => {
    onConfirm(selectedOption);
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-gray-500 bg-opacity-50">
      <div className="w-full max-w-lg rounded-lg bg-white p-6 shadow-lg">
        <h2 className="mb-4 text-xl font-semibold">{message.title}</h2>
        {option1 && (
          <div
            className={`mb-4 flex items-center gap-3 rounded-xl p-2 ${
              selectedOption === "option1"
                ? "border-3 border-yellow-400 bg-yellow-100"
                : ""
            }`}
          >
            <input
              type="radio"
              id="option1"
              name="boardingPoint"
              className="h-5 w-5"
              checked={selectedOption === "option1"}
              onChange={() => setSelectedOption("option1")}
            />
            <div className="flex flex-col gap-1">
              <div className="rounded-lg">{option1.subTitle}</div>
              <p className=" text-xs text-gray-500">{option1.content}</p>
            </div>
          </div>
        )}
        {option2 && (
          <div
            className={`mb-4 flex items-center gap-3 rounded-xl p-2 ${
              selectedOption === "option2"
                ? "border-3 border-yellow-400 bg-yellow-100"
                : ""
            }`}
          >
            <input
              type="radio"
              id="option1"
              name="boardingPoint"
              className="h-8 w-8"
              checked={selectedOption === "option2"}
              onChange={() => setSelectedOption("option2")}
              hidden={!option1}
            />
            <div className="flex flex-col gap-1">
              <div className="rounded-lg"> {option2.subTitle}</div>
              <p className=" text-xs text-gray-500">{option2.content}</p>
              <span className="text-center text-sm  text-gray-400">
                <div className="flex items-center justify-end gap-2">
                  {creditLoading && <Spinner color="primary" />}
                  Credit Needed: {neededCreditPoint}
                  <Tooltip
                    content="The number of credits that will be used when you run or save this plan."
                    color="primary"
                    showArrow={true}
                    placement="top"
                  >
                    <Image
                      src={`/icons/routePlan/routePlancoin.svg`}
                      alt={""}
                      width={25}
                      height={25}
                    />
                  </Tooltip>
                </div>
              </span>
            </div>
          </div>
        )}

        <div className="mt-6 flex justify-between gap-4">
          <button
            type="button"
            className="w-full rounded-lg bg-gray-300 px-4 py-2 font-medium text-gray-700"
            onClick={() => closePopup()}
          >
            Cancel
          </button>
          <button
            type="button"
            className="w-full rounded-lg bg-black px-4 py-2 font-medium text-white"
            onClick={() => clickYes()}
            disabled={neededCreditPoint === 0}
          >
            Confirm
          </button>
        </div>
      </div>
    </div>
  );
};
